import type { VoidFunctionComponent } from 'react';
import cx from 'classnames';
import styles from '../../ReleaseGroupsRevamp.module.less';
import Button, { BUTTON_SIZE, BUTTON_TYPE, ButtonGroup, TooltipButton } from '../../../../../../generic/Button';
import { Icon, icons } from '../../../../../../generic';
import Flex from '../../../../../../generic/Flex';
import type { ReleaseGroupState } from '../../../hooks/useReleaseGroupState';

type Props = {
  pageTitle: string;
  saveButtonText: string;
  cancelButtonText?: string;
  validationErrors: ReturnType<ReleaseGroupState['validate']>;
  isLoading?: boolean;
  onCancel: () => void;
  onSave: () => void;
};

const ReleaseGroupsHeader: VoidFunctionComponent<Props> = (props) => {
  const tooltipMessage = props.validationErrors.join(' ');
  return (
    <div className={cx(styles.section, styles.header)}>
      <div className={styles.title}>
        {props.pageTitle}
      </div>
      <ButtonGroup>
        <Button type={BUTTON_TYPE.SECONDARY} size={BUTTON_SIZE.LARGE} onClick={props.onCancel}>
          {props.cancelButtonText || 'Cancel'}
        </Button>
        <TooltipButton
          id="release-groups-header-save-button-tooltip"
          tooltip={tooltipMessage}
          size={BUTTON_SIZE.LARGE}
          onClick={props.onSave}
          isDisabled={props.validationErrors.length > 0 || props.isLoading}
        >
          {/*
            We're using a custom loading icon instead of a LoaderButton in order to utilize the TooltipButton generic
          */}
          <Flex gap={8} align="center">
            {props.saveButtonText}
            {props.isLoading && <Icon icon={icons.circleO} hasSpin />}
          </Flex>
        </TooltipButton>
      </ButtonGroup>
    </div>
  );
};

export default ReleaseGroupsHeader;
